export const NUMBER_OF_SLIDES_IN_CACHE = 5;
